package com.hyperether.goodjob.repository.remote.auth

import kotlinx.serialization.Serializable

@Serializable
data class MicrosoftLoginRequest(
    val tenantId: String?,
    val email: String?,
    val name: String?
)